// Different than debounce, see example: http://demo.nimius.net/debounce_throttle/
function throttle(func) {
	const wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

	var timer = null;
	return function () {
	  var _this = this;
  
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		args[_key] = arguments[_key];
	  }
  
	  if (timer === null) {
		timer = setTimeout(function () {
		  func.apply(_this, args);
		  timer = null;
		}, wait);
	  }
	};
}
module.exports = throttle;
